import { reviewStatusBadge } from "@/components/ResearchCms";
import type { LifecycleStep } from "@/components/ResearchCms/LifecycleStepper/LifecycleStepper";
import type { EditorialWriteStatus } from "../types";

// The final pill follows the badge, so a live edition renames it to "Released". The button keeps
// naming the transition it performs — advancing an item approves it; the edition releases it.
function releaseStep(editionStatus?: string | null): LifecycleStep<EditorialWriteStatus> {
  const approvedLabel = reviewStatusBadge("ready_for_release").label;
  const label = reviewStatusBadge("ready_for_release", editionStatus).label;

  return label === approvedLabel
    ? { key: "ready_for_release", label }
    : { key: "ready_for_release", label, actionLabel: `Mark ${approvedLabel}` };
}

// Each pill names the state the item is in, so its wording comes from the badge map rather than a
// second copy of the same strings.
function lifecycleSteps(editionStatus?: string | null): LifecycleStep<EditorialWriteStatus>[] {
  return [
    { key: "pending", label: reviewStatusBadge("pending", editionStatus).label },
    {
      key: "ready_for_editing",
      label: reviewStatusBadge("ready_for_editing", editionStatus).label,
      // "Mark Editing" reads as a state, not an action, so this one step names its own button.
      actionLabel: "Mark Ready for Editing",
    },
    { key: "ready_for_translation", label: "Ready for Translation" },
    releaseStep(editionStatus),
  ];
}

export const EDITORIAL_LIFECYCLE_STEPS: LifecycleStep<EditorialWriteStatus>[] = lifecycleSteps();

export function editorialLifecycleSteps(
  showTranslationStep: boolean,
  editionStatus?: string | null,
): LifecycleStep<EditorialWriteStatus>[] {
  const steps = lifecycleSteps(editionStatus);

  return showTranslationStep ? steps : steps.filter(step => step.key !== "ready_for_translation");
}
